/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class QueryOperatorNary extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("QueryOperatorNary");
    }

    getFixupPrototypeFunction() { return QueryOperatorNary.fixupPrototype; }

    static newInstance(model: Partial<QueryOperatorNary>): QueryOperatorNary {
        let obj = Object.assign(new QueryOperatorNary(), model);
        QueryOperatorNary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<QueryOperatorNary>): QueryOperatorNary {
        if (!model) return null;
        return QueryOperatorNary.newInstance(<QueryOperatorNary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: QueryOperatorNary) {
        if (!obj) return;

        models.QueryOperatorNary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: QueryOperatorNary): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, QueryOperatorNary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.terms) {
            for (let val of this.terms) {
                models.QueryOperator.fixupPrototype(val);
            }
        }
    }

    terms: Array<models.QueryOperator>;

}
